import {
	CURRENT_SCHEDULE,
	SET_CURRENT_SCHEDULE,
	RECENT_SCHEDULES,
	SET_RECENT_SCHEDULES
} from './environment-mutation-type';
import { TOAST_MESSAGES_PUSH } from '@/sections/toast-mutation-types';
import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import { formatDate } from '@/utils/datetime';
import _ from 'lodash';

let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'environments',
	namespaced: true,
	state: {
		[CURRENT_SCHEDULE]: {},
		[RECENT_SCHEDULES]: {}
	},
	mutations: {
		[SET_RECENT_SCHEDULES](state, obj) {
			state[RECENT_SCHEDULES] = obj;
		},
		[SET_CURRENT_SCHEDULE](state, obj) {
			state[CURRENT_SCHEDULE] = obj;
		}
	},
	actions: {
		async [SET_RECENT_SCHEDULES]({ commit, dispatch }, parameters) {
			commit(SET_RECENT_SCHEDULES, {});
			commit(SET_CURRENT_SCHEDULE, {});
			await api
				.get(buildRoute(`/erzschedules/`, parameters))
				.then(resp => {
					if (resp.items.length) {
						let recentSchedule = [];
						let currentSchedule = resp.items.find(
							item => item.status === 'SCHEDULED'
						);
						if (!_.isEmpty(currentSchedule)) {
							currentSchedule.actionComment = '';
							commit(SET_CURRENT_SCHEDULE, currentSchedule);
						}

						recentSchedule = resp.items.filter(
							item => item.status !== 'SCHEDULED'
						);
						if (
							_.isEmpty(currentSchedule) &&
							recentSchedule.length > 5
						) {
							recentSchedule = recentSchedule.slice(0, 5);
						}

						const newResponse = {
							...resp,
							items: recentSchedule
						};

						commit(SET_RECENT_SCHEDULES, newResponse);
					}
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
		},
		async getSecheduleById({ dispatch }, id) {
			let schedule = {};
			await api
				.get(`/erzschedules/${id}`)
				.then(resp => {
					schedule = _.cloneDeep(resp);
				})
				.catch(error => {
					const errorMessage = error
						? error
						: `Schedule ${id} does not exist.`;
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: 400,
							message: errorMessage
						},
						{
							root: true
						}
					);
				});

			return schedule;
		},
		async saveSchedule({ commit, dispatch }, payload) {
			const parseScheduleDate = date => {
				// Create a new date in UTC adjusted to 10:30 AM of the specified day
				const utcDate = new Date(
					Date.UTC(
						date.getFullYear(), // Get the year
						date.getMonth(), // Get the month (0-11)
						date.getDate(), // Get the day of the month (1-31)
						10, // Set the hour to 10 AM
						30 // Set the minutes to 30
					)
				);

				// Return the adjusted date as an ISO string
				return utcDate.toISOString();
			};

			let result = {};
			let isSuccessful = true;
			let verbiage = 'successfully';
			let action = payload.reschedulingNeeded
				? 'rescheduled'
				: payload.status === 'STOPPED'
				? 'stopped'
				: payload.id
				? 'edited'
				: 'created';
			let errorMessage = '';

			if (payload.scheduledDate) {
				payload.scheduledDate = parseScheduleDate(
					new Date(payload.scheduledDate)
				);
			} else {
				const tomorrow = formatDate(
					new Date(new Date().setDate(new Date().getDate() + 1))
				);
				parseScheduleDate(tomorrow);
			}

			if (payload.id) {
				await api
					.put(`/erzschedules`, payload)
					.then(resp => {
						result = _.cloneDeep(resp);
					})
					.catch(error => {
						if (error) {
							errorMessage = error;
						}
						isSuccessful = false;
						verbiage = 'unsuccessfully';
					});
			} else {
				if (payload.status) {
					delete payload.status;
				}
				if (payload.reschedulingNeeded) {
					delete payload.reschedulingNeeded;
				}
				await api
					.post('/erzschedules', payload)
					.then(resp => {
						result = _.cloneDeep(resp);
					})
					.catch(error => {
						if (error) {
							errorMessage = error;
						}
						isSuccessful = false;
						verbiage = 'unsuccessfully';
					});
			}
			if (isSuccessful && !_.isEmpty(result)) {
				commit(SET_CURRENT_SCHEDULE, result);
			}
			dispatch(
				TOAST_MESSAGES_PUSH,
				{
					statusCode: isSuccessful ? 200 : 400,
					message: errorMessage
						? errorMessage
						: `Schedule ${verbiage} ${action}`
				},
				{
					root: true
				}
			);
			return result;
		},
		async updateCustomerSchedule({ dispatch }, payload) {
			let result = {};
			await api
				.put(`/erzschedules/customers/${payload.action}`, payload)
				.then(resp => {
					result = _.cloneDeep(resp);
				})
				.catch(error => {
					if (error) {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: 'An error occurred. Please try again.'
							},
							{
								root: true
							}
						);
					}
				});

			return result;
		}
	}
};
